import EditorAbstractField from "./EditorAbstractField.mjs";
import {Input, InputGroup, InputGroupText} from "reactstrap";
import TextLabel from "../../controls/TextLabel.mjs";

const EditorTextField = class extends EditorAbstractField {
	field() {
		return(
			<>
				{ this.textareaField() }
				<InputGroup>
					<InputGroupText>
						<TextLabel value={"Placeholder"} />
					</InputGroupText>
					<Input
						value={ this.state.value?.placeholder || '' }
						onChange={ e => {
							this.setValue('placeholder', e.target.value || undefined );
						}}
					/>
					<InputGroupText>
						<TextLabel value={"Rows"} />:
					</InputGroupText>
					<Input
						bsSize={"sm"}
						type={"number"}
						min={0}
						max={20}
						placeholder={'—'}
						value={ this.state.value?.rows || '' }
						onChange={ e => {
							const v = parseInt(e.target.value || '0');
							this.setValue('rows', v || undefined );
						}}
					/>
				</InputGroup>
			</>
		)
	}
}

export default EditorTextField;